
export class ProjectPausedLifecycleSetterViewModel
{
    projectId: string | null = null;
    opened: boolean = false;

    show(projectId: string)
    {
        this.projectId = projectId;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.projectId = null;
    }
}
